import { Tyre } from '@/Features/Tyres';

const searchInput = document.querySelector('input#search');
const clearButton = document.querySelector('button#clear-filters');
const tyreRows = document.querySelectorAll('tr[data-tyre-id]');
const sizeFilters = document.querySelectorAll('input[data-filter="size"]');

const initialTyres = window.allTyres;

let searchTerm = '';
let allTyres: Tyre[] = [];

if (initialTyres) {
  Object.values(initialTyres).forEach((value) => {
    allTyres = allTyres.concat(value);
  });
}

const showAllTables = (event?: Event) => {
  const sizes = document.querySelectorAll('input[data-filter="size"]');
  const tables = document.querySelectorAll(`[data-tyre-size]`);

  tables.forEach((table) => {
    table.classList.remove('hidden');
  });
  sizes.forEach((size) => {
    if (event && event.target === size) return;
    (size as HTMLInputElement).checked = false;
  });
};

const clearFilters = () => {
  if (searchInput && searchInput instanceof HTMLInputElement) {
    searchInput.value = '';
    searchTerm = '';
    displayTyres();
    showAllTables();
    const allCheckbox = document.querySelector('input[data-filter="size"][value="all"]');
    if (allCheckbox) {
      (allCheckbox as HTMLInputElement).checked = true;
    }
  }
};

const validSearch = (text: string | null | undefined) => {
  return text?.toLowerCase().includes(searchTerm.toLowerCase());
};
const filterTyres = () => {
  return allTyres.filter(
    (tyre) => validSearch(tyre.brand) || validSearch(tyre.size) || validSearch(tyre.pattern) || validSearch(tyre.tyre_type) || validSearch(tyre.ply),
  );
};

function displayTyres() {
  const filteredTyres = filterTyres();

  tyreRows.forEach((row) => {
    const tyreId = row.getAttribute('data-tyre-id');
    if (!tyreId) return;
    const tyre = filteredTyres.find((t) => t.id === parseInt(tyreId));
    if (tyre) {
      row.classList.remove('hidden');
    } else {
      row.classList.add('hidden');
    }
  });

  const tyreTables = document.querySelectorAll(`[data-tyre-size]`);

  // Then, iterate through each tyre size table and hide it if no tyre rows are visible within it
  tyreTables.forEach((table) => {
    const visibleRowsInTable = table.querySelectorAll('tr[data-tyre-id]:not(.hidden)');
    console.log(visibleRowsInTable);
    if (visibleRowsInTable.length === 0) {
      table.classList.add('hidden');
    } else {
      table.classList.remove('hidden');
    }
  });
}

if (searchInput) {
  let timeout: ReturnType<typeof setTimeout>;
  searchInput.addEventListener('input', (event: Event) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      if (event.target && event.target instanceof HTMLInputElement) {
        searchTerm = event.target.value;
        displayTyres();
      }
    }, 500);
  });
}

sizeFilters.forEach((filter) => {
  filter.addEventListener('change', (event) => {
    const sizes = document.querySelectorAll('input[data-filter="size"]');

    //Toggle sizes if all is selected or vice versa
    sizes.forEach((size) => {
      if ((size as HTMLInputElement).value === 'all' && (size as HTMLInputElement).checked) {
        showAllTables(event);
        return;
      } else if ((size as HTMLInputElement).value !== 'all' && (size as HTMLInputElement).checked) {
        const allCheckbox = document.querySelector('input[data-filter="size"][value="all"]');
        if (allCheckbox) {
          (allCheckbox as HTMLInputElement).checked = false;
        }
        return;
      }
    });

    //handle filtering of sizes
    for (let i = 0; i < sizes.length; i++) {
      const size = sizes[i] as HTMLInputElement;

      if (size.value !== 'all') {
        const table = document.querySelector(`[data-tyre-size='${size.value}']`);
        if (!table) return;
        if (size.checked) {
          table.classList.remove('hidden');
        } else {
          table.classList.add('hidden');
        }
      } else {
        const tables = document.querySelectorAll(`[data-tyre-size]`);
        tables.forEach((table) => {
          if (size.checked) {
            table.classList.remove('hidden');
          } else {
            table.classList.add('hidden');
          }
        });
        if (size.checked) {
          break;
        }
      }
    }
  });
});

if (clearButton) {
  clearButton.addEventListener('click', clearFilters);
}
